import { css } from "styled-components";
import token from "styled-token";
import { StyledText } from "../../components/Text/Text";
import { StyledIcon } from "../../components/Icon/Icon";
import { hoverMediaQueryMixin } from "../hoverMediaQueryMixin";
/** @class AccordionHeaderMixin */

/** @method */

export var AccordionHeaderMixin = function AccordionHeaderMixin(props) {
  return token({
    backgroundColor: "AccordionHeader.backgroundColor",
    backgroundColorHover: "AccordionHeader.backgroundColorHover",
    borderRadius: "AccordionHeader.borderRadius",
    padding: "AccordionHeader.padding"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
        backgroundColorHover = _ref.backgroundColorHover,
        borderRadius = _ref.borderRadius,
        padding = _ref.padding;
    return css(["align-items:center;background-color:", ";border-radius:", "px;cursor:pointer;display:flex;padding:", "px;> ", "{flex-shrink:0;}&[aria-expanded=\"true\"],&:hover,&:focus{background-color:", ";}", ";&[aria-expanded=\"true\"]{border-radius:", "px ", "px 0 0;> ", "{transform:rotate(180deg);}}"], backgroundColor, borderRadius, padding, StyledIcon, backgroundColorHover, hoverMediaQueryMixin("\n                " + StyledText + ":first-child {\n                    text-decoration: underline;\n                }\n            "), borderRadius, borderRadius, StyledIcon);
  })(props);
};